import styled from 'styled-components';
import {
  grayDarkSphera,
  greenSp,
  grayLightSphera,
  whiteSphera,
  blackSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const SignupContainer = styled.section`
  display: flex;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const SignupInfo = styled.div`
  width: 50%;
  padding: 10% 0 5% 5%;

  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    line-height: 50px;
    width: 82%;

    > span {
      color: ${greenSp};
    }
  }

  > p {
    color: ${blackSphera};
    font-size: 1.6vw;
    width: 82%;

    > span {
      font-weight: bold;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      line-height: 40px;

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    padding: 0 0 5% 5%;

    > h2 {
      font-size: 7vw;
      line-height: 40px;
      width: 95%;
      margin-bottom: 0;

      > span {
      }
    }

    > p {
      font-size: 6vw;
      width: 95%;

      > span {
      }
    }
  }
`;

export const SignupForm = styled.div`
  width: 50%;
  padding: 0 0 10% 0;
  background-image: url('https://finsphera-webapp-resources.s3.amazonaws.com/img_inv_signup.png');
  background-repeat: no-repeat;
  > form {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 70%;
    margin: 15% auto 0 auto;
    padding: 5%;
    border-radius: 5px;
    background-color: ${whiteSphera};

    > h3 {
      color: ${blackSphera};
      font-size: 1.6vw;
      text-align: center;
      margin-bottom: 2%;
    }

    > input:nth-child(2) {
      font-size: 1rem;
      padding-bottom: 1%;
      border: none;
      border-bottom: 1px solid ${grayLightSphera};
      margin-bottom: 2.5%;

      &::placeholder {
        color: ${grayLightSphera};
      }
    }

    > div:nth-child(3),
    > div:nth-child(4) {
      display: flex;
      margin-top: 1%;
      margin-bottom: 2.5%;
      padding-bottom: 1%;
      border-bottom: 1px solid ${grayLightSphera};

      > input {
        font-size: 1rem;
        width: 90%;
        padding-bottom: 1%;
        border: none;

        &::placeholder {
          color: ${grayLightSphera};
        }
      }

      > figure:nth-child(2) {
        width: 20px;
        height: 19px;
        margin-right: 2.5%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      > figure:nth-child(3) {
        width: 25px;
        height: 20px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    > h4 {
      font-size: 0.8rem;
      margin-bottom: 3%;
      color: ${blackSphera};

      > span {
        color: ${greenSp};
        font-weight: bold;
        cursor: pointer;
      }
    }

    > div:nth-child(7) {
      display: flex;
      align-items: center;
      margin: 1.5% 0 7.5% 0;

      > input {
        margin-right: 2.5%;
        cursor: pointer;
        accent-color: ${greenSp};
      }

      > p {
        font-size: 0.9rem;
        color: ${blackSphera};

        > a {
          color: ${greenSp};
          font-weight: bold;
          text-decoration: none;
        }
      }
    }

    > input[type='submit'] {
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.2vw;
      text-decoration: none;
      text-align: center;
      line-height: 50px;
      width: 60%;
      height: 50px;
      margin: auto;
      border: none;
      border-radius: 5px;
      background-color: ${blackSphera};
      cursor: pointer;
    }

    > p:nth-child(9) {
      font-size: 1.2vw;
      color: ${blackSphera};
      text-align: center;
      margin-top: 5%;
      margin-bottom: 2%;
    }

    > a:nth-child(10) {
      font-size: 1.2vw;
      font-weight: bold;
      color: ${greenSp};
      text-decoration: none;
      text-align: center;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > form {
      > h3 {
      }

      > input:nth-child(2) {
        &::placeholder {
        }
      }

      > div:nth-child(3),
      > div:nth-child(4) {
        > input {
          &::placeholder {
          }
        }

        figure {
          img {
          }
        }
      }

      > h4 {
        > span {
        }
      }

      > div:nth-child(7) {
        > input {
        }

        > p {
          > a {
          }
        }
      }

      > input[type='submit'] {
        line-height: 40px;
        height: 40px;
      }

      > p:nth-child(9) {
      }

      > a:nth-child(10) {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;

    > form {
      width: 95%;
      margin: 5% auto;

      > h3 {
        font-size: 5vw;
      }

      > input:nth-child(2) {
        font-size: 1rem;

        &::placeholder {
        }
      }

      > div:nth-child(3),
      > div:nth-child(4) {
        margin-bottom: 5%;

        > input {
          font-size: 1rem;
          width: 90%;
          &::placeholder {
          }
        }
      }

      > div:nth-child(7) {
        > input {
          margin-top: 2%;
          margin-right: 2.5%;
        }

        > p {
          font-size: 0.8rem;
        }
      }

      > input[type='submit'] {
        font-size: 4.5vw;
        width: 95%;
      }

      > p:nth-child(9) {
        font-size: 0.9rem;
      }

      > a:nth-child(10) {
        font-size: 0.9rem;
      }
    }
  }
`;

export const UserType = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 5%;
  margin-bottom: 5%;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 40%;

    > input {
      color: ${grayDarkSphera};
      cursor: pointer;
      accent-color: ${greenSp};
    }

    > label {
      margin-left: 5%;
      color: ${greenSp};
      font-size: 1.2vw;
      font-weight: bold;
    }

    > img {
      width: 15px;
      height: auto;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > input {
      }
      > label {
      }
      > img {
      }
    }
  }

  @media (max-width: 600px) {
    display: flex;
    justify-content: space-around;
    margin-top: 5%;
    margin-bottom: 5%;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 40%;

      > input {
      }

      > label {
        font-size: 4.2vw;
      }

      > img {
      }
    }
  }
`;
